import InviteActions from '../../actions/InviteActions';
import InviteContainer from './InviteContainer';
import InviteStageStyled from './InviteStageStyled';
import Message from '../message/Message';
import PropTypes from 'prop-types';
import React from 'react';
import SquareButton from '../squareButton/SquareButton';
import {withRouter} from 'react-router';
import {generateRouteTo} from '../../utils/route';

class InviteSuccess extends React.Component {
  static propTypes = {
    history: PropTypes.object,
    inviteStore: PropTypes.object,
    location: PropTypes.object,
  };

  handleSendMore = () => {
    InviteActions.reset();
  };

  handleFinish = () => {
    InviteActions.reset();
    const path = this.props.inviteStore.prevPath;
    if (path) {
      this.props.history.push(path);
    } else {
      this.props.history.push(generateRouteTo('/', this.props.location));
    }
  };

  render() {
    return (
      <InviteStageStyled className="successStage">
        <InviteContainer className="InviteContainer">
          <h1 className="site-block-page-title">
            <Message code="epic.code.invite.title" />
          </h1>
          <div className="site-block">
            <div className="site-block-header">
              <h1 className="site-block-title">
                <Message code="epic.code.invite.success.title" />
              </h1>
              <p className="text-center">
                <Message code="epic.code.invite.success.msg" />
              </p>
              <div className="clearfix" />
            </div>
            <div className="buttonContainer">
              <SquareButton
                handleClick={this.handleFinish}
                config={{buttonStyle: 'btn-primary', inline: true, width: '260px'}}>
                <Message code="epic.common.finish" />
              </SquareButton>
              <SquareButton
                handleClick={this.handleSendMore}
                config={{buttonStyle: 'btn-default', inline: true, width: '260px'}}>
                <Message code="epic.code.invite.success.sendMore" />
              </SquareButton>
            </div>
          </div>
        </InviteContainer>
      </InviteStageStyled>
    );
  }
}

export default withRouter(InviteSuccess);
